module.exports = __webpack_public_path__ + "media/Icons/super_owner_badge-e866f4b1.png";